var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/src/array.js
// module id = 27
// module chunks = 0